var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3996 6.0001C10.3996 5.50304 9.99667 5.1001 9.49961 5.1001C9.00255 5.1001 8.59961 5.50304 8.59961 6.0001V10.5001C8.59961 10.8753 8.83232 11.2111 9.1836 11.3428L13.1836 12.8428C13.649 13.0173 14.1678 12.7815 14.3423 12.3161C14.5168 11.8507 14.281 11.3319 13.8156 11.1574L10.3996 9.8764V6.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99961 0.100098C4.53199 0.100098 0.0996094 4.53248 0.0996094 10.0001C0.0996094 15.4677 4.53199 19.9001 9.99961 19.9001C15.4672 19.9001 19.8996 15.4677 19.8996 10.0001C19.8996 4.53248 15.4672 0.100098 9.99961 0.100098ZM1.89961 10.0001C1.89961 5.52659 5.5261 1.9001 9.99961 1.9001C14.4731 1.9001 18.0996 5.52659 18.0996 10.0001C18.0996 14.4736 14.4731 18.1001 9.99961 18.1001C5.5261 18.1001 1.89961 14.4736 1.89961 10.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5345a4e3797ab6afe3d309369ec90308.svg";
export { ForwardRef as ReactComponent };